(() => {
  function element(tag,text,className) {
    const node=document.createElement(tag);
    if (text!==undefined) node.textContent=text;
    if (className) node.className=className;
    return node;
  }
  function initialize(root) {
    if (root.dataset.ready) return;
    root.dataset.ready='true';
    const form=root.querySelector('[data-lookup]'),button=root.querySelector('[data-submit]');
    const error=root.querySelector('[data-error]'),result=root.querySelector('[data-result]');
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if (button.disabled) return;
      error.hidden=true;
      result.replaceChildren(element('p','Checking your order…'));
      result.setAttribute('aria-busy','true');
      button.disabled=true;
      const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),35000);
      try {
        const path=root.dataset.endpoint;
        if (!/^\/apps\/[a-zA-Z0-9_/-]+$/.test(path)) throw new Error('Order lookup is being set up. Please try again later.');
        const fields=new FormData(form);
        const response=await fetch(path,{method:'POST',headers:{'Content-Type':'application/json'},cache:'no-store',
          body:JSON.stringify({order:fields.get('order'),postal:fields.get('postal')}),signal:controller.signal});
        let data;
        try { data=await response.json(); }
        catch { throw new Error('Order updates are temporarily unavailable. Please try again shortly.'); }
        if (!response.ok || data.error) throw new Error(data.error||'Order updates are temporarily unavailable. Please try again shortly.');
        if (typeof data.title!=='string' || typeof data.message!=='string' || !Number.isInteger(data.step)) throw new Error('Order updates are temporarily unavailable. Please try again shortly.');
        const fragment=document.createDocumentFragment();
        const pickup=data.deliveryMode==='pickup';
        fragment.append(element('p','Order #'+data.orderNumber,'jcc-track__order'),element('h2',data.title),element('p',data.message));
        if (data.step>0 && data.step<4) {
          const eta=element('div',undefined,'jcc-track__eta');
          eta.append(element('small',pickup?'Estimated pickup-ready date':'Estimated ship date'),element('strong',data.eta||'Being updated'),
            element('small',pickup?'Please wait for your ready-for-pickup notification before collecting your order.':data.eta?'Delivery time is additional.':'We’ll show your estimate when it’s available.'));
          fragment.append(eta);
        }
        if (data.step>0) {
          const steps=element('ol',undefined,'jcc-track__steps');
          ['Order received','Preparing your order','Collecting your items',pickup?'Preparing for pickup':'Packing your order',data.completion==='ready'?'Ready for pickup':'Order fulfilled'].forEach((label,index)=>{
            const item=element('li',label,index<data.step?'is-done':index===data.step?'is-current':'');
            if (index===data.step) { item.setAttribute('aria-current','step'); item.append(element('small','Current step')); }
            steps.append(item);
          });
          fragment.append(steps);
        }
        result.replaceChildren(fragment);
        result.focus({preventScroll:true});
      } catch (failure) {
        result.replaceChildren(element('h2','Your order’s journey'),element('p','Enter your order details to check its progress.'));
        const message=failure.name==='AbortError'?'The lookup took too long. Please try again.':failure.message;
        error.textContent=message==='Failed to fetch'?'We couldn’t connect. Please try again shortly.':message;
        error.hidden=false;
      } finally {
        clearTimeout(timeout); button.disabled=false; result.removeAttribute('aria-busy');
      }
    });
  }
  document.querySelectorAll('[data-jcc-tracker]').forEach(initialize);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-jcc-tracker]').forEach(initialize));
})();
